import React from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import VMasker from 'vanilla-masker';

import { Typography, Chip } from '@material-ui/core';
import HtmlTooltip from 'components/HTMLTooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faCheck } from '@fortawesome/free-solid-svg-icons';

import { getEventColor } from 'pages/Scheduling/components/resources';

export default function SchedulingEvent({ title, quantity, time, startDateTime, endDateTime, type, isDelivery, situationId, plate, street, name, phone, email }) {
  const history = useHistory();

  const isNewScheduling =
    history.location.pathname == '/novo-agendamento-servico' ||
    history.location.pathname == '/editar-agendamento-servico';

  const isManyDays = moment(startDateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(endDateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');

  return(
    <HtmlTooltip
      disableHoverListener={type == 'others'}
      placement='top'
      title={
        <div style={{ width: 250 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography color='primary'>
              <b>{title}</b>
            </Typography>
            {!isNewScheduling && (
              <FontAwesomeIcon
                color='#022A5C'
                size='lg'
                icon={faList}
              />
            )}
          </div>
          {!isManyDays && (
            <Typography color='primary'>
              {moment(startDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM')}
              <br />
              {time}
            </Typography>
          )}
          {isManyDays && (
            <Typography color='primary'>
              {moment(startDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM')} - {moment(endDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM')}
              <br />
              {time}
            </Typography>
          )}
          {!!street && (
            <Typography color='textSecondary'>
              <b>{street}</b>
            </Typography>
          )}
          {!!plate && (
            <Typography color='textSecondary'>
              <b>{VMasker.toAlphaNumeric(plate)}</b>
            </Typography>
          )}
          {!!name && (
            <Typography color='textSecondary'>
              <b>{name}</b>
            </Typography>
          )}
          {!!phone && (
            <Typography color='textSecondary'>
              <b>{JSON.parse(phone)[0]}</b>
            </Typography>
          )}
          {!!email && (
            <Typography color='textSecondary'>
              <b>{email}</b>
            </Typography>
          )}
          {(+situationId == 1) && (
            <Chip
              style={{ backgroundColor: 'rgba(245, 185, 65, 0.2)', color: '#F5B941', height: 20, marginTop: 10 }}
              label={
                <Typography>Aguardando Confirmação</Typography>
              }
            />
          )}
          {(+situationId == 2) && (
            <Chip
              style={{ backgroundColor: 'rgba(19, 188, 75, 0.2)', color: '#13BC4B', height: 20, marginTop: 10 }}
              label={
                <Typography>Agendamento Confirmado</Typography>
              }
            />
          )}
          {isDelivery && (
            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 10, marginTop: 10 }}>
              <FontAwesomeIcon
                color='#13BC4B'
                size='lg'
                icon={faCheck}
              />
              <Typography color='textSecondary'>
                Este serviço é um delivery
              </Typography>
            </div>
          )}
        </div>
      }
    >
      <div style={{ width: '100%', height: '100%', overflowY: 'auto', backgroundColor: getEventColor(situationId), cursor: 'pointer', padding: 5, borderRadius: 5, overflow: 'hidden' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <Typography variant='body2' style={{ color: '#FFFFFF' }}>
            <b>{title}</b>
          </Typography>
          {(quantity > 1) && (
            <Chip
              style={{ height: 20, backgroundColor: '#FFFFFF' }}
              label={
                <Typography variant='body2' style={{ color: getEventColor(situationId) }}>
                  <b>+ {quantity}</b>
                </Typography>
              }
            />
          )}
        </div>
        {!isManyDays && (
          <Typography variant='body2' style={{ color: '#FFFFFF' }}>
            <b>{time}</b>
          </Typography>
        )}
        {isManyDays && (
          <Typography variant='body2' style={{ color: '#FFFFFF' }}>
            <b>{moment(startDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM')} - {moment(endDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM')}</b>
            <br />
            <b>{time}</b>
          </Typography>
        )}
      </div>
    </HtmlTooltip>
  );
}